/* eslint-disable react/prop-types */
import React from 'react';

const List = ({
  key, onChange, name, id, labelText, checked,
}) => (
  <li className="radio-login" key={key}>
    <input
      type="radio"
      id={id}
      onChange={onChange}
      name={name}
      value={id}
      checked={checked}
    />
    <span />
    <label htmlFor={id}>
      <p>
        {labelText}
      </p>
    </label>
  </li>
);

export default List;
